exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".events-categoryexplorer-component{padding-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/events/categoryexplorer.scss
// module id = 1019
// module chunks = 0